import { DateTypeArg } from '../types';
import React, { useCallback } from 'react';
import DatePicker from 'react-datepicker';
import useScreenWidth from 'shared/hooks/useScreenWidth';
import { SCREENS } from 'tailwind/consts';

type Props = {
  fromDate: string | null;
  toDate: string | null;
  onChange: (e: DateTypeArg) => void;
  onClear: () => void;
};

type ButtonProps = {
  value: string;
  onClick: () => void;
  mobileBreakpoint: number;
};

const DateInputButton = React.forwardRef<HTMLDivElement>((props, ref) => {
  const { onClick, value, mobileBreakpoint = SCREENS.lg } = props as ButtonProps;

  const screenWidth = useScreenWidth();
  const isMobileScreen = screenWidth < mobileBreakpoint;

  return (
    <div
      className={`relative tracking-tight min-w-[172px] max-w-[380px] rounded-full bg-white px-3.5 ${
        isMobileScreen ? 'py-1.5' : 'py-2'
      } text-left border border-palette-color-bg-grey disabled:text-palette-secondary/40 disabled:border-palette-color-bg-grey/40`}
      onClick={onClick}
      ref={ref}
    >
      <span className="text-sm text-palette-secondary-grey mr-1 whitespace-nowrap">Created Date:</span>
      <span className="text-sm text-black truncate break-all pr-4">{value}</span>
    </div>
  );
});

function DateInput({ fromDate, toDate, onChange, onClear }: Props) {
  const strToDate = (dateString: string | null) => (dateString ? new Date(dateString) : null);

  const changeCallback = useCallback(
    (value: [Date | null, Date | null]) => {
      !value[0] && !value[1] ? onClear() : onChange(value);
    },
    [onChange, onClear]
  );

  return (
    <DatePicker
      customInput={<DateInputButton />}
      dateFormat="yyyy-MM-dd"
      onChange={changeCallback}
      startDate={strToDate(fromDate)}
      endDate={strToDate(toDate)}
      selectsRange={true}
      closeOnScroll={(e) => e.target === document}
      isClearable={true}
    />
  );
}

export default DateInput;
